import { render } from "./InboxLauncher.vue?vue&type=template&id=830d1652"
import script from "./InboxLauncher.vue?vue&type=script&lang=js"
export * from "./InboxLauncher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__